import { t } from "@impero-com/common/utils/i18n";
import { Button, InformationModal } from "@impero-com/ui";
import { Input, notification } from "antd";

interface ShareableLinkPopupProps {
    linkUrl: string;
    onClose: () => void;
    open?: boolean;
}

// The popup that is shown when the user clicks "Copy Link".
export function ShareableLinkPopup({
    linkUrl,
    onClose,
    open = true,
}: ShareableLinkPopupProps) {
    return (
        <InformationModal
            open={open}
            onClose={onClose}
            type="info"
            icon="duplicate"
            title={t("ShareableLinkPopup_Title")}
            // Wider than a plain message: the link has to be readable.
            width={520}
            footer={
                <Button variant="primary" onClick={onClose}>
                    {t("Close")}
                </Button>
            }
        >
            {t("ShareableLinkPopup_Description")}
            <Input
                type="text"
                readOnly
                onClick={(event) => {
                    event.currentTarget.setSelectionRange(0, linkUrl.length);
                    navigator.clipboard.writeText(linkUrl).then(() => {
                        notification.success({
                            message: t("ShareableLinkPopup_CopiedToClipboard"),
                        });
                    });
                }}
                value={linkUrl}
            />
        </InformationModal>
    );
}
